import { tProvidersProps } from '../../providers/LayoutProvider/Layout.types.ts';
import { ChatContext } from './Chat.constants.ts';
import { useChat } from './Chat.hook.ts';

export default function ChatProvider(props: tProvidersProps) {
  const { children } = props;
  const chatContainer = useChat();

  return (
    <ChatContext.Provider value={chatContainer}>
      {children}
    </ChatContext.Provider>
  );
}
